<div class="container">
    <h1>Por favor espera, estamos buscando la página</h1>
    <img src="/assets/ilustraciones/house-searching-animate_2.svg">
</div>
